import React, { useState } from "react";
import {
  Box,
  Heading,
  FormControl,
  FormLabel,
  Input,
  Button,
  VStack,
  Text,
  useToast,
} from "@chakra-ui/react";
import axios from "axios";
import { getToken, canManageData } from "utils/auth";
import config from "config";

const AddFamily = () => {
  const [familyCode, setFamilyCode] = useState("");
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const history = useHistory();

  React.useEffect(() => {
    if (!canManageData()) {
      toast({
        title: "Access Restricted",
        description: "Only administrators and moderators can create families.",
        status: "warning",
        duration: 4000,
        isClosable: true,
      });
      history.push("/txd/families");
    }
  }, []);

  // Validate Family Code
  const validateFamilyCode = (code) => {
    const regex = /^[A-Z]([A-Z0-9-]*[0-9])?$/;
    
    // Length validation
    if (code.length < 2 || code.length > 15) {
      return "Family code must be between 2 and 15 characters.";
    }
    
    // Regular expression validation
    if (!regex.test(code)) {
      return "Family code must start with a capital letter, contain only uppercase letters, numbers, and dashes, and end with a number.";
    }
    
    // Check for consecutive dashes
    if (code.includes("--")) {
      return "Family code cannot contain consecutive dashes.";
    }

    return null;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const validationError = validateFamilyCode(familyCode);
    if (validationError) {
      toast({
        title: "Validation Error",
        description: validationError,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    setLoading(true);

    try {
      const token = getToken()
      const response = await axios.post(
        `${config.API_URL}/individuals/families`, // Replace with your actual API endpoint
        {
          family_code: familyCode,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      
      toast({
        title: "Family created successfully",
        description: "The new family has been created.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      // Redirect to families list page
      history.push("/txd/families");
    } catch (error) {
      toast({
        title: "Error",
        description: "An error occurred while creating the family.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box  p={6} mx="auto">
      <Heading mb={6} color="teal.500">
        Add New Family
      </Heading>

      <VStack spacing={4} as="form" onSubmit={handleSubmit}>
        <FormControl isRequired>
          <FormLabel>Family Code</FormLabel>
          <Input
            type="text"
            value={familyCode}
            onChange={(e) => setFamilyCode(e.target.value)}
            placeholder="Enter family code"
          />
        </FormControl>

        <Button
          colorScheme="teal"
          type="submit"
          isLoading={loading}
          loadingText="Creating Family"
        >
          Create Family
        </Button>
      </VStack>

      <Text mt={4} textAlign="center">
        <Button variant="link" onClick={() => history.push("/txd/individuals/families")}>
          Back to Families List
        </Button>
      </Text>
    </Box>
  );
};

export default AddFamily;
